import React from "react";

function Dataentry() {
  return (
    <div className="container">
      <h1 className="text-3xl font-bold">Data Form</h1>
      <form>
          <input type="text" />
          <input type="submit" />
      </form>
    </div>
  );
}

export default Dataentry;